import { Quote, Star } from "lucide-react";
import { REVIEWS } from "@/data/site";
import { Eyebrow, Reveal } from "./Reveal";

const Card = ({ r, i }) => (
  <Reveal delay={(i % 3) * 0.08} className="mb-5 break-inside-avoid">
    <figure data-testid={`review-${i}`} className="rounded-3xl border border-[var(--leaf)]/12 bg-white p-7 transition-[transform,box-shadow] duration-500 hover:-translate-y-1 hover:shadow-[0_30px_60px_-30px_rgba(15,74,19,0.35)]">
      <div className="flex items-center justify-between">
        <span className="flex text-[var(--leaf)]">{[0, 1, 2, 3, 4].map((s) => <Star key={s} className="h-4 w-4 fill-current" />)}</span>
        <span className="rounded-full bg-[var(--sprout)] px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider text-[var(--leaf-deep)]">{r.source}</span>
      </div>
      <blockquote className="mt-5 text-[15px] leading-relaxed text-[var(--ink)]">“{r.text}”</blockquote>
      <figcaption className="mt-6 flex items-center gap-3">
        <span className="grid h-10 w-10 place-items-center rounded-full bg-[var(--leaf)] font-display text-sm font-black text-white">{r.name[0]}</span>
        <span>
          <span className="block font-bold">{r.name}</span>
          <span className="block text-xs text-[var(--muted)]">{r.date}</span>
        </span>
      </figcaption>
    </figure>
  </Reveal>
);

export const Reviews = () => (
  <section id="reviews" data-testid="reviews-section" className="relative bg-[var(--mist)] py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mb-14 grid gap-8 lg:grid-cols-[1.2fr_1fr] lg:items-end">
        <div>
          <Eyebrow>What neighbors say</Eyebrow>
          <h2 className="mt-5 font-display text-4xl font-black leading-[0.95] sm:text-6xl">“Highly recommend <span className="font-serif-i font-normal text-[var(--leaf)]">Hunter and his crew.”</span></h2>
        </div>
        <div className="flex items-center gap-5 lg:justify-self-end" data-testid="reviews-summary">
          <Quote className="h-12 w-12 text-[var(--leaf)]/30" />
          <div>
            <p className="font-display text-5xl font-black text-[var(--leaf)]">100%</p>
            <p className="text-sm font-medium text-[var(--muted)]">recommend on Facebook · 5★ on Yelp</p>
          </div>
        </div>
      </Reveal>
      <div className="columns-1 gap-5 md:columns-2 lg:columns-3">
        {REVIEWS.map((r, i) => <Card key={r.name} r={r} i={i} />)}
      </div>
    </div>
  </section>
);
